import iconAppLogo from "../../images/app-logos/logo-128.png";
import iconRedError from "../../../Icons/icons-red/error.png";


// import iconHome from "../../../Icons/NV/Nav/home nv.png";
// import iconUploaded from "../../../Icons/NV/Nav/uploaded.png";
// import iconSaved from "../../../Icons/NV/Nav/saved.png";
// import iconNotifications from "../../../Icons/NV/Nav/notification.png";


import iconHome from "../../../Icons/NV/nav-nv/n-act/home.png";
import iconNotifications from "../../../Icons/NV/nav-nv/n-act/notification.png";
import iconUploaded from "../../../Icons/NV/nav-nv/n-act/acti.png";



import iconListings from "../../../Icons/icons-charcoal-dark/listed.png";
import iconHelp from "../../../Icons/icons-black/help.png";
import iconInfo from "../../../Icons/icons-black/info.png";
import iconAdd from "../../../Icons/icons-black/add.png";

import iconInstall from "../../../Icons//icons-beige/icon-install.png";
import iconBlackExit from "../../../Icons/icons-black/exit.png";
import profileImgPlaceHolder from "../../../Icons/icons-white/profile-img-placeholder.png";
import iconExit from "../../../Icons/icons-charcoal-dark/exit.png";
import NVIconWhiteBack from "../../../Icons/NV/white/back.png";




class GenerateHtml {
  _mainMenuGenerate(userName, email, origImg) {


    let profileImgPlaceHolderUse = profileImgPlaceHolder;

    if (origImg) {
      profileImgPlaceHolderUse = origImg;
    }
    let userNameForUse = userName;
    let style = "";
    console.log(userName);

    if (!userName || userName === "sin nombre") {
      userNameForUse = "! completa tu perfil de vendedor";
      style = 'style="color: #FF8400"';
      console.log("NOT LOGGED IN");
    }

    return `  
<div class="MainMenuCon1A">
  <div id="MainMenuCon1" class="MainMenuCon1">
    <div class="MainMenuCon2B">
      <div class="ButtonCloseMenuParrentCon">
        <button class="ButtonCloseMenu topRightExitButtonOnFullScreenWindow" id="ButtonCloseMenu">
          <img height="12px" src="${iconBlackExit}"/>
        </button>
      </div>
    <div class="MainMenuCon2">
      <div id="MainMenuCon3OpenProfile" class="MainMenuCon3">
        <div class="ProfileOpenFotoConBForMenu">
        <img data-origimg="${origImg.join("°-°|°-°?°-°|°-°")}" id="ProfileFotoInMenuTop" class="ProfileOpenFoto ImgForBigDisplay hasOriginalImages" src="${profileImgPlaceHolderUse}"/>
        </div>
        <div class="MainMenuCon4">
          <div ${style} class="MainMenuProfileName">
            ${userNameForUse}
          </div>
          <div class="MainMenuProfileEmail">
            ${email}
          </div>
        </div>
      </div>
      <div
        id="PreInstallConInMenu"
        class="PrePageConForInstallationConB"
      >
        <div class="PrePageCon2A3">
          <div class="PrePageCon2A3Title">Instalar esta aplicación</div>
          <div class="PrePageCon2A4">
            <div class="PrePageCon2A4Description">
              Ahora también puedes instalar Mercado MAI en tu celular como una
              aplicación móvil, y lo puedes abrir con un solo click.
            </div>
            <div id="ButtonInstallAppInMenu" class="PrePageCon2A4Button">
              <img height="32px" src="${iconInstall}"/>
              <div id="installBtn" class="PrePageCon2A4ButtonText">
                Instalar ahora
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="MainMenuCon5" style="display: none">
        <div class="MainMenuCon5B">
          <div class="MainMenuCon6 openButtonFromMenu" data-open="home" style="display: none;">
              <div class="MainMenuCon7">
              <img height="16px" src="${iconHome}" alt="" />
              <div class="MainMenuOptionText">Inicio</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="notifications">
              <div class="MainMenuCon7">
              <img height="16px" src="${iconNotifications}" alt="" />
              <div class="MainMenuOptionText">Notificaciones</div>
              </div>
          </div>
        </div>
      </div>
      <div class="MainMenuCon5" style="display: none">
        <div class="MainMenuCon5B">        
          <div class="MainMenuCon6 openButtonFromMenu" data-open="business">
              <div class="MainMenuCon7">
              <img height="16px" src="${iconUploaded}" alt="" />
              <div class="MainMenuOptionText">Mis publicaciones</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="saved" style="display: none;">
              <div class="MainMenuCon7">
              <img height="16px" src="${iconUploaded}" alt="" />
              <div class="MainMenuOptionText">Mis guardados</div>
              </div>
          </div>
        </div>
      </div>
      <div class="MainMenuCon5">
        <div class="MainMenuCon5B">
          <div class="MainMenuCon6 openButtonFromMenu" data-open="about">
              <div class="MainMenuCon7">
              <img class="MainMenuCon7B" height="16px" src="${iconAppLogo}" alt="" />
              <div class="MainMenuOptionText">Acerca de Mercado MAI</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="moreapps" style="display: none;">
              <div class="MainMenuCon7">
              <img height="16px" src="${iconAdd}" alt="" />
              <div class="MainMenuOptionText">Mas aplicaciones</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="help" style="display: none;">
              <div class="MainMenuCon7">
              <img height="16px" src="${iconHelp}" alt="" />
              <div class="MainMenuOptionText">Ayuda</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="termsofuse">
              <div class="MainMenuCon7">
              <img height="16px" src="${iconInfo}" alt="" />
              <div class="MainMenuOptionText">Terminos de uso de la aplicación y política de privacidad</div>
              </div>
          </div>
        </div>

      </div>


      <div class="MainMenuCon5">
        <div class="MainMenuCon5B">
          <div class="MainMenuCon6 openButtonFromMenu" data-open="report-an-error">
              <div class="MainMenuCon7">
              <img class="MainMenuCon7B" height="16px" src="${iconRedError}" alt="" />
              <div class="MainMenuOptionText">Reportar un error</div>
              </div>
          </div>
        </div>

      </div>



    </div>
    </div>
  </div>
</div>`;
  }
}
export default new GenerateHtml();
